var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.combinedStyle),on:{"click":function($event){return _vm.$emit('click', $event.target ? $event.target.value : false)},"keydown":function($event){return _vm.$emit('click', $event.target ? $event.target.value : false)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }